import React from 'react';

function ContactUs({ onBack }) {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <button onClick={onBack} className="legal-back-btn">← Back to Home</button>
        <h1>Contact Us</h1>
        <p className="legal-effective-date">Last updated: June 24, 2026</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Get in Touch</h2>
          <p>
            We'd love to hear from you! Whether you have a question about StoryMeal, feedback
            on our platform, a story submission inquiry, or a business proposal, our team is
            here to help.
          </p>
          <p>
            We aim to respond to all inquiries within 2–3 business days. For urgent matters,
            please use the email address listed below.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Primary Contact Email</h2>
          <p>
            For all general inquiries, support requests, and correspondence, please reach out
            to us at:
          </p>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:helpdesk@austrasoft.com">helpdesk@austrasoft.com</a>
          </p>
          <p>
            This is the official helpdesk email managed by Austrasoft, the parent company
            that powers StoryMeal. All messages sent to this address are reviewed by our
            support team.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. What to Contact Us About</h2>
          <h3>General Inquiries</h3>
          <p>
            Questions about StoryMeal, how the platform works, account help, or general
            feedback.
          </p>

          <h3>Story Submissions & Writing</h3>
          <p>
            Questions about publishing your story, content guidelines, or author support.
            Note: StoryMeal is currently invite-based for new authors — please contact us
            if you'd like to contribute.
          </p>

          <h3>Advertising & Partnerships</h3>
          <p>
            For advertising inquiries, brand partnerships, sponsored content opportunities,
            or media kit requests, please email us with the subject line "Advertising Inquiry"
            and we'll route your message to the appropriate team.
          </p>

          <h3>Privacy & Data Requests</h3>
          <p>
            To exercise your privacy rights (access, deletion, correction of your data),
            please email us with the subject line "Privacy Request" and include sufficient
            detail so we can verify your identity.
          </p>

          <h3>Copyright & DMCA</h3>
          <p>
            If you believe content on StoryMeal infringes your copyright, please email us
            with the subject line "DMCA Notice" and include the information required by
            17 U.S.C. § 512.
          </p>

          <h3>Bug Reports & Technical Issues</h3>
          <p>
            Found a bug or experiencing a technical issue? Please include screenshots, your
            browser/device, and steps to reproduce the problem.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Response Times</h2>
          <p>
            We strive to respond to all inquiries promptly. Typical response times are:
          </p>
          <ul>
            <li><strong>General inquiries:</strong> 2–3 business days</li>
            <li><strong>Privacy & data requests:</strong> Within 30 days as required by applicable law</li>
            <li><strong>DMCA notices:</strong> Within 5 business days</li>
            <li><strong>Advertising inquiries:</strong> 3–5 business days</li>
            <li><strong>Bug reports:</strong> Acknowledged within 3 business days</li>
          </ul>
          <p>
            Please note that response times may be longer during weekends, holidays, or
            periods of high volume.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Mailing Address</h2>
          <p>
            For formal correspondence, legal notices, or physical mail, you can reach us at:
          </p>
          <p>
            <strong>Austrasoft</strong><br />
            Attn: StoryMeal Support<br />
            Website:{' '}
            <a href="https://austrasoft.com" target="_blank" rel="noopener noreferrer">Austrasoft.com</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Follow Us</h2>
          <p>
            Stay connected with StoryMeal for updates, new features, and community highlights.
            For the latest news, visit our website at{' '}
            <a href="https://austrasoft.com" target="_blank" rel="noopener noreferrer">Austrasoft.com</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Language</h2>
          <p>
            Our support team primarily communicates in English. We will do our best to
            accommodate inquiries in other languages, but response times may be longer for
            non-English messages.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Thank You</h2>
          <p>
            Thank you for being part of the StoryMeal community. Your feedback, stories,
            and support help us make the platform better for everyone. We look forward to
            hearing from you!
          </p>
        </section>
      </div>
    </div>
  );
}

export default ContactUs;